import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import constant from '../../../utils/Constant';
import config from '../../../config/config';
import Loader from '../../partials/Loader';

const {
    UPDATE_MOBILE_BAR_QUOTATION_END_POINT,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    STATUS_200,
    STATUS_401,
    LOGOUT,
} = constant;

const UpdateQuotation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    const MobileData = location.state?.mobileBarData || [];

    const [formData, setFormData] = useState({
        _id: MobileData.id,
        vendorId: MobileData.vendor_id,
        fullName: MobileData.full_name,
        email: MobileData.email,
        phone: MobileData.phone,
        eventDate: MobileData.event_date,
        startTime: MobileData.event_start_time,
        endTime: MobileData.event_end_time,
        eventType: MobileData.event_type,
        event_type_other: MobileData.event_type_other,
        otherEventType: MobileData.email,
        guests: MobileData.no_of_guest,
        venueName: MobileData.venue_name,
        venueAddress: MobileData.address,
        vendorAccess: MobileData.easy_loading,
        barSetup: MobileData.bar_type,
        numBartenders: MobileData.bartenders,
        alcoholProvision: MobileData.alcohol_provision,
        drinkStyles: MobileData.drink_style.map((pre) => pre),
        glassware: MobileData.glassware,
        brandedElements: MobileData.branded_elements,
        budget: MobileData.budget_range,
        notes: MobileData.note,
        status: MobileData.status
    });

    // * guest option for selection
    const guestOptions = ['50–75', '76–100', '101–150', '151–200', '201–250', '251–300', '301–400', '401–500', '500+'];

    // * handle change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData((prevForm) => {
                const currentValues = prevForm[name];
                const updatedValues = checked
                    ? [...currentValues, value]
                    : currentValues.filter((item) => item !== value);
                return { ...prevForm, [name]: updatedValues };
            });
        } else {
            setFormData((prevForm) => ({ ...prevForm, [name]: value }));
        }
    };

    // * budget option for selection
    const budgetOptions = [
        'R5,000–R10,000', 'R10,001–R15,000', 'R15,001–R25,000',
        'R25,001–R50,000', 'R50,001–R75,000',
        'R75,001–R100,000', 'R100,001+'
    ];

    // * bar option for selection
    const barOptions = [
        'Rustic Bar Only', 'Full Mobile Truck',
    ];

    // * execute update mobile bar api
    const executeUpdateMobileBarApi = async () => {

        // * set loading and disable button
        setLoading(trueValue);
        setDisableButton(trueValue);

        const sendRequest = {
            vendor_id: formData.vendorId,
            full_name: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            event_date: formData.eventDate,
            event_start_time: formData.startTime,
            event_end_time: formData.endTime,
            event_type: formData.eventType,
            event_type_other: formData.event_type_other,
            no_of_guest: formData.guests,
            venue_name: formData.venueName,
            address: formData.venueAddress,
            easy_loading: formData.vendorAccess,
            bar_type: formData.barSetup,
            bartenders: formData.numBartenders,
            alcohol_provision: formData.alcoholProvision,
            drink_style: formData.drinkStyles,
            glassware: formData.glassware,
            branded_elements: formData.brandedElements,
            budget_range: formData.budget,
            note: formData.notes,
            status: formData.status,
            id: formData._id
        }

        try {
            const apiUrl = `${config.appBaseUrl + UPDATE_MOBILE_BAR_QUOTATION_END_POINT}`;

            // * execute put request
            const response = await axios.post(apiUrl, sendRequest, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const apiResponse = response.data;

            // * if response is success
            if (apiResponse.code === STATUS_200) {
                toast.success(apiResponse.message)
            }
        } catch (error) {
            handleError(error);
            // * if token is expired
            if (error.response?.data.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setLoading(falseValue);
            setDisableButton(falseValue);
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === 'object') {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error('Something was broken!');
        }
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className='page-content px-4' style={{ zIndex: '1' }}>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12 px-0'>
                            <div className='page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>Update Quotation</h4>

                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0 d-flex flex-wrap gap-1'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active pointer' onClick={() => navigate(-1)}>Mobile Bar</li>
                                        <li className='breadcrumb-item active'>Update Quotation</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <form>
                                    <div className='row'>
                                        {/* //* left side */}
                                        <div className='col-12 col-md-6'>
                                            <h5 className='fw-bold quotation-title'>Contact Information:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Full Name</label>
                                                    <input type='text' name='fullName' className='form-control m-0' value={formData.fullName} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Email Address</label>
                                                    <input type='email' name='email' className='form-control m-0' value={formData.email} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Phone Number</label>
                                                    <input type='text' name='phone' className='form-control m-0' value={formData.phone} required onChange={handleChange} />
                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Event Details:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Date</label>
                                                    <input type='date' name='eventDate' className='form-control' min={new Date().toISOString().split('T')[0]} value={formData.eventDate} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Bar Start Time</label>
                                                    <input
                                                        type='time'
                                                        className='form-control'
                                                        name='startTime'
                                                        value={formData.startTime}
                                                        required
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Bar End Time</label>
                                                    <input
                                                        type='time'
                                                        className='form-control'
                                                        name='endTime'
                                                        value={formData.endTime}
                                                        required
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Estimated Number of Guests</label>
                                                    <select name='guests' className='form-control' value={formData.guests} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        {guestOptions.map((guest) => (
                                                            <option key={guest} value={guest}>{guest}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Type</label>
                                                    <select name='eventType' className='form-control' value={formData.eventType} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        <option value='Wedding'>Wedding</option>
                                                        <option value='Birthday'>Birthday</option>
                                                        <option value='Corporate Event'>Corporate Event</option>
                                                        <option value='Private Party'>Private Party</option>
                                                        <option value='Product Launch'>Product Launch</option>
                                                        <option value='Other'>Other</option>
                                                    </select>
                                                    {formData.eventType === 'Other' && (
                                                        <input
                                                            type='text'
                                                            name='event_type_other'
                                                            className='form-control mt-3'
                                                            placeholder='Please specify'
                                                            value={formData.event_type_other || ''}
                                                            onChange={handleChange}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Location Details:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Venue Name</label>
                                                    <input type='text' name='venueName' className='form-control m-0' value={formData.venueName} onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Venue Address / Location</label>
                                                    <input type='text' name='venueAddress' className='form-control m-0' value={formData.venueAddress} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-12'>
                                                    <label className='mb-0 fw-normal'>
                                                        Will the vendor have easy access for loading/unloading?
                                                    </label>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='Yes'
                                                            id='accessYes'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'Yes'}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessYes'>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='No'
                                                            id='accessNo'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'No'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessNo'>
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='Unsure'
                                                            id='accessUnsure'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'Unsure'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessUnsure'>
                                                            Unsure
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mt-2'>
                                                        <label htmlFor='status_vendor' className='fw-normal mb-0'>Status</label>
                                                        <select
                                                            name='status'
                                                            id='status_vendor'
                                                            className='form-select'
                                                            value={formData.status}
                                                            onChange={handleChange}
                                                        >
                                                            <option value=''>Select status</option>
                                                            <option value='0'>New</option>
                                                            <option value='1'>Replied</option>
                                                            <option value='2'>Close</option>
                                                        </select>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                        {/* //* right side */}
                                        <div className='col-12 col-md-6'>
                                            <h5 className='fw-bold quotation-title'>Bar Requirements:</h5>
                                            <div className='row'>
                                                {/* <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal'>Bar Type</label>
                                                    <select name='barSetup' className='form-control' value={formData.barSetup} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        {barOptions.map((bar) => (
                                                            <option key={bar} value={bar}>{bar}</option>
                                                        ))}
                                                    </select>
                                                </div> */}
                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal'>Bartenders</label>
                                                    <input
                                                        type='number'
                                                        name='numBartenders'
                                                        className='form-control m-0'
                                                        placeholder='Enter specific number'
                                                        value={formData.numBartenders}
                                                        onChange={handleChange}
                                                    />
                                                    {formData.bartenderOption === 'custom' && (
                                                        <input
                                                            type='text'
                                                            name='specificBartenders'
                                                            className='form-control mt-2'
                                                            placeholder='Enter specific number'
                                                            onChange={handleChange}
                                                        />
                                                    )}
                                                </div>

                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>Alcohol Provision</label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='alcoholProvision'
                                                            value='I will supply the alcohol'
                                                            id='alcoholClient'
                                                            className='form-check-input'
                                                            checked={formData.alcoholProvision === 'I will supply the alcohol'}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='alcoholClient'>
                                                            I will supply the alcohol
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='alcoholProvision'
                                                            value='Vendor to supply alcohol'
                                                            id='alcoholVendor'
                                                            className='form-check-input'
                                                            checked={formData.alcoholProvision === 'Vendor to supply alcohol'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='alcoholVendor'>
                                                            Vendor to supply alcohol
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='alcoholProvision'
                                                            value='No alcohol needed'
                                                            id='alcoholNone'
                                                            className='form-check-input'
                                                            checked={formData.alcoholProvision === 'No alcohol needed'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='alcoholNone'>
                                                            No alcohol needed
                                                        </label>
                                                    </div>
                                                </div>



                                                <div className='col-md-12 mb-3'>
                                                    <label className='fw-normal'>Preferred Drink Style</label>
                                                    <div className='formData-check d-flex flex-wrap gap-3'>
                                                        {['Cocktails', 'Wine', 'Beer', 'Spirits', 'Mocktails'].map((drink) => (
                                                            <div key={drink}>
                                                                <input
                                                                    className='formData-check-input'
                                                                    type='checkbox'
                                                                    name='drinkStyles'
                                                                    value={drink}
                                                                    checked={formData.drinkStyles.includes(drink)}
                                                                    onChange={handleChange}
                                                                    id={drink}
                                                                />
                                                                <label className='formData-check-label ms-1 fw-normal' htmlFor={drink}>
                                                                    {drink}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>Do you require glassware?</label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='glassware'
                                                            value='No glassware'
                                                            id='glasswareNo'
                                                            className='form-check-input'
                                                            required
                                                            checked={formData.glassware === 'No glassware'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='glasswareNo'>No glassware</label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='glassware'
                                                            value='Glassware only'
                                                            id='glasswareOnly'
                                                            className='form-check-input'
                                                            checked={formData.glassware === 'Glassware only'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='glasswareOnly'>Glassware only</label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='glassware'
                                                            value='Yes, full glassware service'
                                                            id='glasswareYes'
                                                            className='form-check-input'
                                                            checked={formData.glassware === 'Yes, full glassware service'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='glasswareYes'>Yes, full glassware service</label>
                                                    </div>
                                                </div> */}


                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>Do you need branded elements?</label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='brandedElements'
                                                            value='Yes'
                                                            id='brandedYes'
                                                            checked={formData.brandedElements === 'Yes'}
                                                            className='form-check-input'
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='brandedYes'>Yes</label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='brandedElements'
                                                            value='No'
                                                            id='brandedNo'
                                                            className='form-check-input'
                                                            checked={formData.brandedElements === 'No'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='brandedNo'>No</label>
                                                    </div>
                                                </div>

                                            </div>

                                            <h5 className='fw-bold quotation-title'>Budget Range:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal'>Approximate Budget</label>
                                                    <select name='budget' className='form-control' value={formData.budget} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        {budgetOptions.map((b) => (
                                                            <option key={b} value={b}>{b}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Additional Notes:</h5>
                                            <div className=''>
                                                <textarea
                                                    name='notes'
                                                    rows='4'
                                                    className='form-control'
                                                    placeholder='E.g., themes, drink menu preferences, load-in limitations...'
                                                    value={formData.notes}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </form>

                                <div className='d-flex align-items-center justify-content-end mt-3'>
                                    <button className='btn btn-primary' onClick={executeUpdateMobileBarApi} disabled={disableButton}>
                                        {!loading ? 'Update' : <Loader />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default UpdateQuotation;